const maintenance = {
  actions: {
    async getUpcomingMaintenance(context, website) {
      return await context.dispatch('getRequest', {
        api: `maintenance/upcoming/${website}`,
      });
    },
  },
};

export default maintenance;
